// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import defaultAvatar from '../../../../assets/img/betting/default_avatar.png';

const Wrap = styled.div`
  margin: 0 auto;
  width: 3em;
  height: 3em;
  min-width: 3em;
  min-height: 3em;
  border-radius: 50%;
  border: solid 1px ${({ theme }) => theme.grids.colors.redlight};
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  width: 100%;
  height: auto;
`;

const Avatar = ({ className, image }) => {
  return (
    <Wrap className={className}>
      <Img
        src={image}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = defaultAvatar;
        }}
      />
    </Wrap>
  );
};

export default Avatar;
